import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WorkspacesManageAccessInfo, UserInfo } from 'src/app/models';
import { WorkspaceService, ToastService } from 'src/app/services';


@Component({
    selector: 'app-manage-access-modal',
    templateUrl: './manage-access-modal.component.html',
    styleUrls: ['./manage-access-modal.component.scss'],
    standalone: false
})
export class ManageAccessModalComponent implements OnInit {

  @Input() collaborator: UserInfo;
  @Output() manageAccess = new EventEmitter();
  workspaces: WorkspacesManageAccessInfo[];
  projectsName: string;

  constructor(
    private activeModal: NgbActiveModal,
    private toastService: ToastService,
    private workspaceService: WorkspaceService) { }

  async ngOnInit() {
    try {
      this.workspaces = (await this.workspaceService.getEntityAccess(this.collaborator.id)).workspaces;
      this.workspaces.forEach(workspace => {
        workspace.isRemoved = false;
        const projectList = [];
        workspace.projects.forEach(project => {
          projectList.push(project.name);
          if (projectList.length > 2) {
            this.projectsName = projectList[0] + ', ' + projectList[1] + ' and other ' + (projectList.length - 1);
          } else if (projectList.length > 1) {
            this.projectsName = projectList[0] + ', ' + projectList[1];
          } else {
            this.projectsName = projectList[0];
          }
        });
      });
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  /**
   * Modal submit. Removes user access from selected workspaces
   */

  async confirmData() {
    Promise.all(
      this.workspaces.map(async workspace => {
        if (workspace.isRemoved) {
          await this.workspaceService.deleteUserFromWorkspace(workspace.id, workspace.type, this.collaborator.id)
          .then(() => {
            this.workspaces = this.workspaces.filter(item => !item.isRemoved);
            this.toastService.showSuccess({
              description: `${this.collaborator.name} has been successfully removed from ${workspace.name}`,
              type: 'success'
            });
          })
          .catch(error => {
            this.toastService.showError(error.error);
            console.error('error =>', error);
          });
        }
      })
    ).then(() => {
      this.manageAccess.emit();
    })
    .catch(error => {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    });

    this.activeModal.close();
  }

  /**
   * Close modal
   */

  onDelete() {
    this.activeModal.close();
  }
}
